/**
 * Helper
 */
var helper = require('../../helper');

$(function() {
    $('.datatable-guardians-key-fee-simple').each(function () {
        let guardianId = $(this).data('guardian'),
            $datatable = $('#datatable-guardians-key-fee-simple-'+guardianId),
            columns = [
                {data: 'due_date', name: 'due_date', orderable: false, searchable: false},
                {data: 'amount', name: 'amount', orderable: false, searchable: false},
                {data: 'previousPaid', name: 'previousPaid', orderable: false, searchable: false},
                {data: 'status', name: 'status', orderable: false, searchable: false}
            ];

        $datatable.DataTable({
            "dom": "<'dt-toolbar dt-toolbar-no-buttons'lf>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "processing": true,
            "serverSide": true,
            "responsive": true,
            "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
            "ajax": {
                "url": helper.getOrigin() + "/api/guardians/"+guardianId+"/key_fee_payments",
                "method": 'POST'
            },
            "bAutoWidth" : false,
            "order": [[ 0, "asc" ]],
            "columns": columns
        });
    });
});
